import React, { useMemo } from 'react';

import { Select } from 'components/shared/Select';

type CategoryOption = { label: string; value: string };

const getSelectedCategoryIds = (raw: unknown): string[] => {
  if (Array.isArray(raw)) {
    return raw.filter((id) => id != null && id !== '').map(String);
  }

  if (raw != null && raw !== '') {
    return [String(raw)];
  }

  return [];
};

const LessonCategorySelectField = ({
  field,
  helpers,
  options,
  loading,
  readOnly,
  haveError,
  className,
  placeholder,
}: {
  field: any;
  helpers: any;
  options: readonly CategoryOption[];
  loading?: boolean;
  readOnly?: boolean;
  haveError?: boolean;
  className?: string;
  placeholder?: string;
}) => {
  const selectedIds = useMemo(
    () => getSelectedCategoryIds(field.value),
    [field.value],
  );

  const value = useMemo(() => {
    if (!selectedIds.length) {
      return [];
    }

    return selectedIds
      .map((id) => options.find((o) => o.value === id))
      .filter(Boolean) as CategoryOption[];
  }, [selectedIds, options]);

  const handleChange = (opts: readonly CategoryOption[] | null) => {
    if (!opts?.length) {
      helpers.setValue([]);

      return;
    }

    helpers.setValue(opts.map((o) => o.value));
  };

  return (
    <Select
      name={field.name}
      onBlur={field.onBlur}
      multi
      searchable
      value={value}
      onChange={handleChange}
      options={options}
      loading={loading}
      isDisabled={readOnly}
      isClearable
      haveError={haveError}
      className={className}
      placeholder={placeholder}
    />
  );
};

export default React.memo(LessonCategorySelectField) as any;
